import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { SESSIONS_CONFIG } from 'src/services/config'
import timeslotsRules from 'src/services/mappings/timeslots_rules.js'
import { date as dateUtils } from 'quasar'

const RESPONSIVE_IMG_SIZES = [
  {
    threshold: '1400',
    name: 'full'
  },
  {
    threshold: '1000',
    name: 'lg'
  },
  {
    threshold: '800',
    name: 'md'
  },
  {
    threshold: '400',
    name: 'sm'
  }
]

const SIZES_ATTR = `
  (max-width: 400px) 400w,
  (min-width: 400px) and (max-width: 800px) 800w,
  (min-width: 800px) and (max-width: 1000px) 1000w,
  (min-width: 1000px) 1400w
`

export function getSizes () {
  return SIZES_ATTR
}

export function getSrc (data = {}) {
  return data.full
}

export function getSrcset (data = {}) {
  let universalSrc = data.md || data.full
  let output = ''

  RESPONSIVE_IMG_SIZES.forEach((o) => {
    if (Object.prototype.hasOwnProperty.call(data, o.name)) {
      output += `${data[o.name]} ${o.threshold}w, `
    } else {
      output += `${universalSrc} ${o.threshold}w, `
    }
  })
  return output
}

export function getCurrentPosition (options = {}) {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })
}

export function preparePhoneNumber (val = '') {
  val = val.replace(/^(06)/g, '+316')
  if (val.charAt(0) !== '+') {
    val = `+${val}`
  }
  const parsedPhoneNumber = parsePhoneNumberFromString(val)

  return parsedPhoneNumber ? parsedPhoneNumber.number : ''
}

export function getSessionKeyByString (val = '') {
  val = val.toLowerCase()
  let sessionKey = SESSIONS_CONFIG.find(o => {
    return o.aliases.includes(val)
  })
  return (sessionKey && sessionKey.key) || val
}

export function getFixedSessionName (date = '') {
  let output = 'morning'

  let dateString = date.split('+')[0]
  let dateObj = new Date(dateString)
  let timeString = dateUtils.formatDate(dateObj, 'HH:mm')

  if (timeString >= '12:00' && timeString < '16:30') {
    output = 'afternoon'
  } else if (timeString >= '16:30' && timeString < '23:59') {
    output = 'evening'
  }

  return output
}

export function prepareObjectBeforeSend (data = {}) {
  for (let key in data) {
    let value = data[key]
    if (typeof value === 'string' || value instanceof String) {
      data[key] = value.trim()
    }
    if (key === 'email') {
      data[key] = value.toLowerCase()
    }
  }
  return data
}

// Check if the time is available for the given location
// NOTE: not used in the project anymore
export function isThisAvailableTime (time, sid) {
  const dateTarget = new Date(time)
  let itemData = timeslotsRules.find(o => o.id === sid)
  if (!itemData) return true

  let ranges = itemData.ranges
  const days = ranges.map(o => dateUtils.formatDate(new Date(o.from), 'YYYY-MM-DD'))
  if (!days.find(v => v === dateUtils.formatDate(dateTarget, 'YYYY-MM-DD'))) return true

  let output = false
  for (let range of ranges) {
    const dateFrom = new Date(range.from)
    const dateTo = new Date(range.to)
    const match = dateUtils.isBetweenDates(dateTarget, dateFrom, dateTo, { inclusiveFrom: true, inclusiveTo: false })
    if (match) output = true
  }

  return output
}
